<template>
    <div class="subnet-list-container init">
        <div class="cps-page-top">
            <div class="jc-page-header">
                <el-page-header :title="$t('subnet.text.subnet')" />
                <div class="jc-box-action">
                    <a v-bind:href="Config.SUBNET_URL" target="_blank"> {{ $t('subnet.help.doc') }}</a>
                </div>
            </div>
            <div class="jc-page-content">
                <div class="jc-container-table">
                    <div class="jc-container-table-actionBar flex-display">
                        <!--刷新、地域、创建-->
                        <el-form class="jc-table-actionBar-item" :inline="true">
                            <el-form-item>
                                <el-button icon="jc-icon-refresh-line" class="jc-button-icon"
                                    @click="updateList('refresh')"></el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-radio-group v-model="region" @change="regionChange">
                                    <el-radio-button v-for="(area, index) in region_map" :key="index" :label="area.region">
                                        {{ area.regionName }}
                                    </el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="openCreateSubnetDialog()">{{ $t('listPage.text.create') }}
                                </el-button>
                            </el-form-item>
                        </el-form>
                        <!--搜索、自定义、下载-->
                        <el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>
                            <el-form-item>
                                <el-input v-entire-placeholder class="search-input"
                                    @keyup.enter.native="updateList('refresh')" :placeholder="currentPlaceholder"
                                    v-model="currentSearchValue" :maxlength="32">
                                    <el-button slot="append" icon="jc-icon-search" class="search-icon"
                                        @click="updateList('refresh')">
                                    </el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-setting" class="jc-button-icon operate-icon"
                                    @click="customVisible = true" :title="$t('listPage.text.customList')"></el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="jc-button-icon operate-icon" icon="jc-icon-download" @click="exportList"
                                    :title="$t('listPage.text.exportList')"></el-button>
                            </el-form-item>
                        </el-form>

                    </div>
                    <el-table @filter-change="filterChange" :data="tableData" class="jc-list-table jc-table-header-cell"
                        v-loading="loading" ref="listTable" :empty-text="$t('speechCraft.listEmptyText')">
                        <!--名称-->
                        <el-table-column :label="$t('subnet.text.name')" min-width="60" key="id"
                            v-if="customInfo !== null && customInfo['name'].selected">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" :content="scope.row.name" placement="bottom">
                                    <a href="javascript:void(0)" @click="jumpToDetail(scope.row.subnetId, region)">{{
                                        scope.row.name
                                        | maybeEmpty }}</a>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <!--主要IPv4 CIDR-->
                        <el-table-column :label="$t('subnet.text.cidr')" min-width="80" prop="cidr"
                            v-if="customInfo !== null && customInfo['cidr'].selected">
                            <template slot-scope="scope">
                                {{ scope.row.cidr | maybeEmpty }}
                            </template>
                        </el-table-column>
                        <!--次要IPv4 CIDR-->
                        <el-table-column :label="$t('subnet.text.subCidr')" min-width="80" prop="secondaryCidr"
                            v-if="customInfo !== null && customInfo['secondaryCidr'].selected">
                            <template slot-scope="scope">
                                {{ scope.row.secondaryCidr | maybeEmpty }}
                            </template>
                        </el-table-column>
                        <!--主要IPv6 CIDR-->
                        <el-table-column prop="ipv6Cidr" :label="$t('subnet.text.primaryIpv6Cidr')" min-width="80"
                            v-if="customInfo !== null && customInfo['ipv6Cidr'].selected">
                            <template slot-scope="scope">
                                {{ scope.row.ipv6Cidr | maybeEmpty }}
                            </template>
                        </el-table-column>
                        <!--所属网络-->
                        <el-table-column prop="vpcName" min-width="80" key="vpcName" :label="$t('subnet.text.netBelongTo')"
                            :filter-multiple="false" :filters="netBelongToFilter" :filter-method="filterNetBelongTo"
                            column-key="netBelongKey" filter-placement="bottom-start"
                            v-if="customInfo !== null && customInfo['belongTo'].selected">
                            <template slot-scope="scope">
                                <a href="javascript:void(0)" @click="jumpToVpcDetail(scope.row, 'source')">
                                    {{ scope.row.vpcName | maybeEmpty }}</a>
                            </template>
                        </el-table-column>
                        <!--可用IPv4/总IPv4-->
                        <el-table-column :label="$t('subnet.text.availableIpToAllIp')" min-width="80"
                            key="availableIpToAllIp" v-if="customInfo !== null && customInfo['ratio'].selected">
                            <template slot-scope="scope">
                                <span>{{ scope.row.availableIpToAllIp | maybeEmpty }}</span>
                            </template>
                        </el-table-column>
                        <!--可用IPv6/总IPv6-->
                        <el-table-column :label="$t('subnet.text.availableIpv6ToAllIp')" min-width="80"
                            key="availableIpv6ToAllIp" v-if="customInfo !== null && customInfo['ipv6Ratio'].selected">
                            <template slot-scope="scope">
                                <span>{{ scope.row.availableIpv6ToAllIp | maybeEmpty }}</span>
                            </template>
                        </el-table-column>
                        <!--创建时间-->
                        <el-table-column prop="createdAt" min-width="70" key="createdAt"
                            :label="$t('detail.text.createTime')"
                            v-if="customInfo !== null && customInfo['datetime'].selected">
                            <template slot-scope="scope">
                                <span>{{ scope.row.createTime | maybeEmpty }}</span>
                            </template>
                        </el-table-column>
                        <!--操作-->
                        <el-table-column key="operation" width="120" :label="$t('listPage.tableLabel.operation')"
                            v-if="customInfo !== null && customInfo['operation'].selected">
                            <template slot-scope="scope">
                                <!--没有资源可以删除，有资源不可以删除-->
                                <template v-if="scope.row.name.indexOf('Default-Game') === -1">
                                    <el-tooltip v-if="scope.row.availableIpCount < scope.row.totalIpCount"
                                        :content="$t('subnet.operations.delete.tip')">
                                        <span
                                            :class="[{ 'a-disabled': scope.row.availableIpCount < scope.row.totalIpCount }]">
                                            {{ $t('subnet.text.delete') }}</span>
                                    </el-tooltip>
                                    <a v-else href="javascript:void(0)"
                                        @click="selectOpts(SubnetOperationConstant.DELETE, scope.row)">
                                        {{ $t('subnet.text.delete') }}</a>
                                </template>
                                <template v-else>
                                    <!-- <el-tooltip :content="$t('privateNetwork.defaultGameVpcTip')">
                                        <span class="a-disabled">
                                            {{ $t('subnet.text.delete') }}</span>
                                    </el-tooltip>

                                    <div slot="content">如需删除请<a :href="Config.WORK_ORDER_URL" target="_blank"
                                            style="color:#2C68FF">{{
                                                $t('create.tooltip.ticket') }}</a>
                                    </div> -->
                                    <el-tooltip placement="bottom" :visible-arrow="false">
                                        <div slot="content">如需删除请<a :href="Config.WORK_ORDER_URL" target="_blank"
                                                style="color:#2C68FF">{{ $t('privateNetInstance.submit') }}</a>
                                        </div>
                                        <label>
                                            <el-button type="text" :disabled="true">
                                                {{ $t('privateNetwork.delete') }}
                                            </el-button>
                                        </label>
                                    </el-tooltip>
                                </template>
                                <a href="javascript:void(0)" class="cps-select-form-item"
                                    v-if="!scope.row.ipv6Cidr && scope.row.vpcIpv6Cidr" @click="openIpv6(scope.row)">
                                    {{ $t('privateNetwork.openIpv6') }}
                                </a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type"></custom>
            <create-subnet :current-region="region" :hasEnableVpcIpv6="hasEnableVpcIpv6"
                @ifDialogVisible="syncCreateDialogVisibleData" @refreshList="updateList('refresh')"
                v-if="subnetDialogVisible" @showIpv6Private="showIpv6Private"></create-subnet>
            <ipv6-subnet :ipv6-dialog-visible="ipv6DialogVisible" :currentRow="currentRow" :region="region"
                @ifIpv6DialogVisible="syncIpv6DialogVisibleData" @refreshList="updateList('refresh')"
                v-if="ipv6DialogVisible">
            </ipv6-subnet>
            <ipv6-private :visible.sync="ipv6PrivateShow" :vpcName="currentObj.name" :vpcId="currentObj.vpcId"
                :region="region" @refresh="closePrivateShow">
            </ipv6-private>
        </div>
        <div ref="footer" class="cps-page-footer block jc-container-table-actionBar" v-if="total > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
import custom from '@/components/common/custom/Custom';
import CreateSubnet from '@/components/subnet/create/Create';
import ipv6Subnet from '@/components/subnet/ipv6Subnet/ipv6Subnet';
import ipv6Private from '@/components/privateNetwork/ipv6Private/ipv6Private';
import { NetworkTypeConstant, SubnetOperationConstant } from '@/common/Constants'
const initPage = 1;
export default {
    components: {
        CreateSubnet,
        custom,
        ipv6Subnet,
        ipv6Private
    },
    name: 'SubnetList',
    data() {
        return {
            timer: [],
            clientToken: Normal.getClientToken(),
            networkTypeMap: {
                basic: this.$t('listPage.text.baseNet')
            },
            currentPage: initPage,
            form: {},
            region_map: [],
            region: null,
            tableData: [],
            totalDiscount: 0,
            loading: false,
            regionMap: {},
            search: 'instanceId',
            // 当前搜索条件(默认按名称进行搜索)
            currentSearch: 'name',
            // 当前搜索input框值
            currentSearchValue: '',
            // 当前搜索条件对应placeholder
            currentPlaceholder: this.$t('eip.placeholder.search.name'),
            // 创建子网弹框是否可见
            subnetDialogVisible: false,
            pageSize: 20,
            pageSizes: [20, 50, 100], // 可选每页展示多少条
            total: 0,
            // 自定义列表是否显示
            customVisible: false,
            // 自定义列表表头
            optionArr: [
                {
                    // 名称
                    label: this.$t('subnet.text.name'),
                    value: 'name'
                },
                {
                    // 主要ipv4 CIDR
                    label: this.$t('subnet.text.cidr'),
                    value: 'cidr'
                },
                {
                    // 次要ipv4 CIDR
                    label: this.$t('subnet.text.subCidr'),
                    value: 'secondaryCidr'
                },
                {
                    // Ipv6 CIDR
                    label: this.$t('subnet.text.primaryIpv6Cidr'),
                    value: 'ipv6Cidr'
                },
                {
                    // 所属网络
                    label: this.$t('subnet.text.netBelongTo'),
                    value: 'belongTo'
                },
                {
                    // 可用 IPv4/总IPv4
                    label: this.$t('subnet.text.availableIpToAllIp'),
                    value: 'ratio'
                },
                {
                    // 已用IPv6/总IPv6
                    label: this.$t('subnet.text.availableIpv6ToAllIp'),
                    value: 'ipv6Ratio'
                },
                {
                    // 创建时间
                    label: this.$t('detail.text.createTime'),
                    value: 'datetime'
                },
                {
                    // 操作
                    label: this.$t('listPage.tableLabel.operation'),
                    value: 'operation'
                }
            ],
            // 自定义列表类型key
            type: 'subnetList',
            // 筛选条件
            filterDataStatus: [],
            filterDataAzs: [],
            filterDataDeviceTypes: [],
            status: '',
            az: '',
            isAbsolute: true,
            deviceType: '',
            // 所属网络下拉选
            netBelongToFilter: [],
            // 当前行的子网名称
            currentRowSubnetName: '',
            // 当前行的子网ID
            currentRowSubnetId: '',
            // 当前所属网络
            currentVpcId: '',
            // 开通ipv6弹框
            ipv6DialogVisible: false,
            // 当前操作行信息
            currentRow: {},
            ipv6PrivateShow: false,
            currentObj: {},
            hasEnableVpcIpv6: false
        };
    },
    computed: {
        customInfo() {
            return this.$store.state.customInfo[this.type];
        },
        SubnetOperationConstant: () => SubnetOperationConstant
    },
    watch: {
        region(newValue) {
            if (newValue) {
                this.regionChange()
            }
        },
    },
    created() {
        if (this.$store.state.customInfo[this.type] === null) {
            this.getCustomInfo();
        }
    },
    mounted() {
        this.getRegion();
    },
    methods: {
        // 打开创建子网弹框
        openCreateSubnetDialog() {
            this.subnetDialogVisible = true;
        },
        // 同步创建子网子组件传出来的dialog是否显示的数据
        syncCreateDialogVisibleData(data) {
            this.subnetDialogVisible = data;
        },
        syncIpv6DialogVisibleData(data) {
            this.ipv6DialogVisible = data;
        },
        // 打开开通ipv6弹框
        openIpv6(row) {
            this.ipv6DialogVisible = true;
            this.currentRow = row;
            // this.ipv6SubnetShow = true;
        },
        // 所属网络过滤方法
        filterNetBelongTo(value, row) {
            if (row.vpcId === value) {
                return true;
            }
            return false;
        },
        // 更多中的操作
        selectOpts(caseOps, row) {
            SubnetPopHelper.operations(caseOps, this, row, 'list');
        },
        getRegion() {
            const params = {
                networkType: NetworkTypeConstant.vpcs
            };
            Ajax.get('api/cps/getRegions', params).then((res) => {
                const target = this;
                if (res.data) {
                    res.data.regions.forEach((region, index) => {
                        if (index === 0) {
                            if (target.$route.query && target.$route.query.region) {
                                target.region = target.$route.query.region;
                            } else {
                                target.region = region.region;
                            }
                        }
                        const tempFormat = {};
                        tempFormat.region = region.region;
                        tempFormat.regionName = region.regionName;
                        target.region_map.push(tempFormat);
                    });
                }
            })
                .catch()

        },
        /**
        * 获取子网列表数据
        * */
        getSubnetListData() {
            this.loading = true;
            const param = {
                region: this.region,
                pageNumber: this.currentPage,
                pageSize: this.pageSize,
            };
            if (this.currentVpcId !== '') {
                param.vpcId = this.currentVpcId;
            }
            const currentSearchValue = this.currentSearchValue;
            const currentSearch = this.currentSearch;
            if (currentSearchValue !== '') {
                switch (currentSearch) {
                    case 'name': {
                        param.name = this.currentSearchValue;
                    }
                    default: {
                    }
                }
            }
            Ajax.get('api/cps/listSubnets', param).then(res => {
                const list = res.data.subnets;
                if (list.length) {
                    /** 
                        格式化可用IP/总IP
                        格式化已用IPv6/总IPv6
                    * */
                    for (const item of list) {
                        item.availableIpToAllIp = `${item.availableIpCount}/${item.totalIpCount}`;
                        if (item.totalIpv6IpCount) {
                            item.availableIpv6ToAllIp = `${item.usedIpv6IpCount}/${item.totalIpv6IpCount}`;
                        } else {
                            item.availableIpv6ToAllIp = '--';
                        }

                    }
                }
                this.tableData = list;
                this.total = res.data.totalCount;
            }).catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    // this.$message.error(json.errmsg);
                    this.tableData = [];
                    this.total = 0;
                } catch (ex) {
                    console.log(ex);
                }
            })
                .finally(() => {
                    this.loading = false;
                });

        },
        /**
        * 获取子网列表
        * @param type
        */
        updateList(type) {
            if (type === 'refresh') {
                this.loading = true;
                this.currentPage = 1;
            }
            this.getSubnetListData();
        },
        regionChange() {
            this.$refs.listTable.clearFilter();
            this.status = '';
            this.deviceType = '';
            this.az = '';
            this.currentSearchValue = '';
            this.currentPage = initPage;
            this.getFilterLists();
            this.updateList('refresh');
        },

        filterAz(value, row) {
            if (row.az === value) {
                this.az = row.az;
                return true;
            }
            return false;
        },
        jumpToDetail(id, region) {
            this.$router.push({
                path: `/subnet/detail`,
                query: {
                    id,
                    region
                }
            });
        },
        // 修改搜索条件
        changeSearch() {
            const searchPlaceholder = this.$t('list.searchPlaceholder');
            const currentSearchVar = this.currentSearch;
            this.currentPlaceholder = searchPlaceholder[currentSearchVar];
            // 清空当前搜索条件
            this.currentSearchValue = '';
        },
        // 导出列表接口
        exportList() {
            let temp = '';
            const target = this;
            if (target.currentSearchValue !== '') {
                temp = `&name=${target.currentSearchValue}`;
            }
            if (target.currentVpcId !== '' && target.currentVpcId !== undefined) {
                temp += `&vpcId=${target.currentVpcId}`;
            }
            const url = `/cps_api/api/export/listSubnets?pageNumber=${target.currentPage}&pageSize=${target.pageSize}&region=${target.region}${temp}`;
            window.open(url, '_self');
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.updateList('refresh');
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.updateList();
        },

        getCustomInfo() {
            const param = {
                pageKey: this.type
            };
            Ajax.get({
                url: '/api/usercenter',
                action: '/getCustomInfo',
                param,
                success: (data) => {
                    if (data.customInfo) {
                        this.$store.commit('GET_CUSTOMINFO', { value: data.customInfo, type: this.type });
                    }
                }
            });
        },
        getFilterLists() {
            const target = this;
            const param = {
                region: this.region,
                pageSize: 100
            };
            Ajax.get({
                url: '/api/cps',
                action: '/listVpcs',
                param,
                success: (data) => {
                    if (data && data.vpcs) {
                        const filterArray = [];
                        for (const item of data.vpcs) {
                            const obj = {
                                text: item.name,
                                value: item.vpcId
                            };
                            filterArray.push(obj);
                        }
                        target.netBelongToFilter = filterArray;
                    }
                }
            });
        },
        filterChange(filter) {
            this.currentPage = 1;
            for (const key in filter) {
                if (key === 'netBelongKey') {
                    this.currentVpcId = filter.netBelongKey[0];
                }
            }
            this.getFilterLists();
            this.getSubnetListData();
        },
        //跳转到VPC详情页
        jumpToVpcDetail(row, tabName) {
            this.$router.push({
                path: `/vpc/detail`,
                query: {
                    region: row.region,
                    vpcName: row.vpcName,
                    tabName,
                    id: row.vpcId
                }
            })
        },

        showIpv6Private(obj) {
            this.ipv6PrivateShow = true;
            this.currentObj = obj;
        },

        closePrivateShow() {
            this.ipv6PrivateShow = false;
            this.hasEnableVpcIpv6 = true;
        }
    },
};
</script>


<style lang="scss">
@import '~@/assets/scss/paginationCommon';
@import '~@/assets/scss/listComon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/subnet/list/List.vue